/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowAction } from '@shared/models/workflow-action';

@Pipe({
    name: 'availableActions',
    standalone: false
})
export class AvailableActionsPipe implements PipeTransform {
  transform(actions: WorkflowAction[]): WorkflowAction[] {
    return actions.filter(action => !action.error && !action.name.startsWith('undo'));
  }
}
